import request from '@/http/request'
export const clcRfidNddcBindReport = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/clcRfidNddcBindReport`,
    params
  )
}

export const clcRfidNddcBindSummary = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/clcRfidNddcBindSummary`,
    params
  )
}
export const exportClcRfidNddcBindReport = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/exportClcRfidNddcBindReport`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const clcRfidNddcBindHistoryReport = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/queryClcRfidNddcBindHistoryReport`,
    params
  )
}
export const clcRfidNddcBindHistorySummary = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/clcRfidNddcBindHistorySummary`,
    params
  )
}
export const exportClcRfidNddcBindHistoryReport = params => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/exportClcRfidNddcBindHistoryReport`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const clcReportPlantList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/rfid-report-service/clc/rfid/nddc/bind/plantList`)
}
